import React from 'react';
import { Button } from './ui/button';
import { whatsappLink } from '../data/mock';

const Hero = ({ onScrollToForm }) => {
  return (
    <section className="hero-section block-light">
      <div className="container">
        <div className="hero-content-grid">
          <div className="hero-text-side">
            <h1 className="hero-large">
              <span className="text-highlight">Bienestar</span> simple.<br />Resultados <span className="text-highlight">reales.</span>
            </h1>
            <p className="hero-description">
              En ZenKo, creemos que sentirse bien no debería ser complicado. Te ayudamos a elegir los suplementos correctos para tus objetivos, con claridad y sin excesos.
            </p>

            <div className="hero-cta-single">
              <Button 
                className="btn-primary" 
                onClick={onScrollToForm}
              >
                Recibe tu guía gratuita
              </Button>
            </div>
          </div>

          <div className="hero-image-side">
            <img 
              src="https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/anik1odp_download-7.png" 
              alt="Suplementos ZenKo" 
              className="hero-main-image"
            />
          </div>
        </div>

        <img 
          src="https://customer-assets.emergentagent.com/job_suspicious-bassi/artifacts/ix5k6uhe_1.1.jpg" 
          alt="ZenKo - Tienda Online" 
          className="logo-large"
        />
      </div>
    </section>
  );
};

export default Hero;